<template>
  <div class="detail-page">
    <Loading v-if="loading"></Loading>
    <template v-else-if="detail.id">
      <!-- 售后信息 -->
      <div class="section">
        <div class="section-title">售后信息</div>
        <div class="info-row">
          <span class="label">售后单号</span>
          <span class="value">{{ detail.afterSaleNo || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">订单号</span>
          <span class="value">{{ detail.orderNo || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">服务类型</span>
          <span class="value">{{ getTypeText(detail.afterSaleType) }}</span>
        </div>
        <div class="info-row">
          <span class="label">申请原因</span>
          <span class="value">{{ detail.reason || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">申请时间</span>
          <span class="value">{{ detail.applyTime || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">申请人ID</span>
          <span class="value">{{ detail.applyId || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">商户</span>
          <span class="value">{{ detail.merchName || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">退款金额</span>
          <span class="value amount">{{
            detail.refundAmount != null ? "￥" + detail.refundAmount : "-"
          }}</span>
        </div>
        <div class="info-row">
          <span class="label">售后状态</span>
          <span class="value">
            <van-tag :type="getStatusType(detail.status)">{{
              getStatusText(detail.status)
            }}</van-tag>
          </span>
        </div>
        <div class="info-row">
          <span class="label">审核人</span>
          <span class="value">{{ detail.auditName || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">审核时间</span>
          <span class="value">{{ detail.auditTime || "-" }}</span>
        </div>
        <div class="info-row">
          <span class="label">审核意见</span>
          <span class="value">{{ detail.auditRemark || "--" }}</span>
        </div>
        <div class="info-row">
          <span class="label">完成时间</span>
          <span class="value">{{ detail.finishTime || "--" }}</span>
        </div>
        <div class="info-row">
          <span class="label">关闭时间</span>
          <span class="value">{{ detail.closeTime || "--" }}</span>
        </div>
      </div>

      <!-- 申请退款商品 -->
      <div class="section">
        <div class="section-title">申请退款商品</div>
        <div
          class="product-item"
          v-for="(product, index) in detail.items"
          :key="product.id || product.orderItemId || index"
        >
          <div class="product-top">
            <span class="product-name">{{ product.skuName || "-" }}</span>
            <span class="product-num">×{{ getQuantity(product) }}</span>
          </div>
          <div class="product-bottom">
            <span class="product-spec">{{ product.skuSpec || "" }}</span>
            <span class="product-price"
              >￥{{ product.refundAmount ?? product.appliedUnitPrice ?? "0.00"
            }}</span>
          </div>
        </div>
        <div v-if="!detail.items || !detail.items.length" class="empty">
          暂无退款商品
        </div>
      </div>
    </template>
    <div v-else class="empty">暂无售后信息</div>
  </div>
</template>
<script>
import { queryDetail } from "@/service/api/retail/afterSale";
import Loading from "../../../components/loading.vue";

export default {
  name: "RetailAfterSaleDetail",
  components: { Loading },
  data() {
    return {
      afterSaleId: this.$route.params.id || "",
      loading: true,
      detail: {},
      // 售后类型：0-仅退款 1-退货退款 2-换货
      typeOptions: [
        { label: "仅退款", value: 0 },
        { label: "退货退款", value: 1 },
        { label: "换货", value: 2 },
      ],
      // 售后状态
      statusOptions: [
        { label: "待审核", value: 100 },
        { label: "已拒绝", value: 200 },
        { label: "待退货", value: 300 },
        { label: "已退货", value: 400 },
        { label: "待退款", value: 500 },
        { label: "部分退款", value: 550 },
        { label: "已退款", value: 600 },
        { label: "已取消", value: 700 },
        { label: "售后完成", value: 800 },
      ],
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    getDetail() {
      this.loading = true;
      queryDetail(this.afterSaleId)
        .then((res) => {
          this.detail = res.data || {};
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getTypeText(type) {
      const opt = this.typeOptions.find((t) => t.value === type);
      return opt ? opt.label : "-";
    },
    getStatusText(status) {
      const opt = this.statusOptions.find((s) => s.value === status);
      return opt ? opt.label : "-";
    },
    getStatusType(status) {
      if (status === 800 || status === 600) return "success";
      if (status === 100 || status === 200) return "danger";
      if (status === 300 || status === 400 || status === 500 || status === 550)
        return "warning";
      return "primary";
    },
    // 数量：称重商品取重量，计件商品取数量
    getQuantity(product) {
      if (product.quantity != null) return product.quantity;
      if (product.weight != null) return product.weight;
      return 1;
    },
  },
};
</script>
<style lang="less" scoped>
.detail-page {
  min-height: 100vh;
  background: #f7f8fa;
  padding: 10px 0;
}

.section {
  background: #fff;
  margin: 0 0 10px;
  padding: 15px 16px;

  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin-bottom: 12px;
  }

  .info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    line-height: 2.2;

    .label {
      color: #666;
    }

    .value {
      color: #333;
      text-align: right;
      word-break: break-all;
    }

    .amount {
      color: #ee0a24;
      font-weight: 600;
    }
  }
}

.product-item {
  padding: 12px 4px;
  border-top: 1px solid #f4f4f4;

  &:first-of-type {
    border-top: none;
  }

  .product-top {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .product-name {
      font-size: 15px;
      color: #333;
    }

    .product-num {
      font-size: 14px;
      color: #999;
    }
  }

  .product-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 8px;

    .product-spec {
      font-size: 13px;
      color: #c8c9cc;
    }

    .product-price {
      font-size: 15px;
      font-weight: 600;
      color: #333;
    }
  }
}

.empty {
  text-align: center;
  color: #c8c9cc;
  font-size: 13px;
  padding: 30px 0;
}
</style>
